// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface CancelableFunction<T extends (...args: any) => any> {
    (this: unknown, ...args: Parameters<T>): void;
    cancel(): void;
}

export default interface RateLimitedAction {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <T extends (...args: any[]) => any>(func: T, waitMS: number): CancelableFunction<T>;
}
